import sortBy from 'lodash/sortBy';

const initialState = {
  lastSync: 0,
  lastRestart: 0,
  errors: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_HEALTH_DATA': {
      const { errors, lastRestart, lastSync } = payload;
      return {
        ...state,
        errors,
        lastRestart,
        lastSync,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Health/Health.reducer.js